<template>
  <div id="cartEntryPageMobile" class="cart-entry-mobile-wrap">
    <recipe-reviewer ref="recipeReviewer" />
    <product-description ref="productDescription" />

    <vs-popup :active.sync="isVariantSelectionOpen" title="Alternatif Ürün Seçimi" id="variant-first-selection">
      <vs-row vs-type="flex" vs-w="12" class="bg-primary2">
        <vs-col vs-type="flex" vs-w="12" vs-justify="space-between" class="mx-5 py-4">
          <vs-button
            radius
            icon-pack="feather"
            icon="icon-x"
            color="tranparent"
            class="bg-secondary text-primary"
            @click="closeVariantSelection"
          ></vs-button>
        </vs-col>
      </vs-row>
      <vs-row v-if="selectedRawMaterial != null" vs-type="flex" vs-w="12" vs-justify="center" class="p-5">
        <vs-col vs-type="flex" class="w-auto mx-5 my-3" v-for="variant in selectedRawMaterial.variants" :key="variant.id">
          <vs-button
            class="half-friendly-border bold sale-box-shadow text-dark"
            :class="{ 'bg-primary text-white': variant.selected }"
            @click="variantSelection(variant)"
            size="large"
            color="transparent"
            >{{ variant.name }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>

    <div v-show="!isExtraSelectionOpen" class="cem-scroll">
      <nav class="cem-segmented" role="tablist" aria-label="Ürün düzenleme">
        <button
          type="button"
          role="tab"
          class="cem-segment"
          :class="{ 'cem-segment--active': mobileTab === 'urun' }"
          @click="mobileTab = 'urun'"
        >
          Ürün
        </button>
        <button
          type="button"
          role="tab"
          class="cem-segment"
          :class="{ 'cem-segment--active': mobileTab === 'ekstra' }"
          @click="mobileTab = 'ekstra'"
        >
          Ekstralar
        </button>
        <button
          type="button"
          role="tab"
          class="cem-segment"
          :class="{ 'cem-segment--active': mobileTab === 'bilgi' }"
          @click="mobileTab = 'bilgi'"
        >
          Bilgi
        </button>
      </nav>

      <section v-show="mobileTab === 'urun'" class="cem-panel" aria-label="Ürün">
        <div class="cem-hero">
          <img
            :src="
              selectedProduct && selectedProduct.imageUrl
                ? $baseUrl + '/' + selectedProduct.imageUrl
                : toUpdateEntry && toUpdateEntry.rawProduct.imageUrl
                  ? $baseUrl + '/' + toUpdateEntry.rawProduct.imageUrl
                  : productPlaceHolder
            "
            class="cem-hero-img"
            alt=""
            @click="openRecipeReviewer"
            @error="onImgError"
          />
        </div>

        <h1 class="cem-title">{{ displayProductTitle }}</h1>
        <div class="cem-price">{{ $toCurrency(selectedRecipe.price) }}</div>
        <div class="cem-chips">
          <span
            v-for="(name, idx) in productName.filter((n) => n)"
            v-show="name"
            :key="'chip-' + idx"
            class="cem-chip"
            >{{ name }}</span
          >
        </div>

        <div class="cem-qty">
          <span class="cem-qty-label">Adet</span>
          <div class="cem-qty-row">
            <button type="button" class="cem-qty-btn" @click="quantity > 1 ? quantity-- : null" aria-label="Azalt">−</button>
            <span class="cem-qty-value">{{ quantity }}</span>
            <button type="button" class="cem-qty-btn" @click="quantity++" aria-label="Artır">+</button>
          </div>
        </div>

        <div
          v-if="isRawMaterialsReload && selectedRecipe.recipeSteps"
          class="cem-steps"
          id="cartEntryRecipeSteps"
        >
          <div
            v-for="step in selectedRecipe.recipeSteps.filter(
              (x) =>
                (x.rawMaterial.variants != null && x.rawMaterial.variants.length > 0) || x.isRemovable === true
            )"
            :key="step.id"
            class="cem-step-card"
          >
            <div
              class="cem-step-head"
              :class="{
                'bg-primary2':
                  step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0,
                'bg-secondary':
                  step.rawMaterial.variants == null || step.rawMaterial.variants.length === 0,
              }"
            >
              <p
                v-if="step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0"
                class="cem-step-head-text"
              >
                {{ step.rawMaterial.name }}
              </p>
              <vs-button
                v-if="step.isRemovable === true"
                icon-pack="feather"
                icon="icon-x"
                color="transparent"
                type="gradient"
                class="cem-step-remove"
                :class="{
                  'text-dark': step.rawMaterial.variants == null || step.rawMaterial.variants.length === 0,
                  'text-white': step.rawMaterial.variants != null && step.rawMaterial.variants.length !== 0,
                }"
                @click="removeRecipeStep(step)"
              />
            </div>
            <div
              class="cem-step-body"
              :class="{ 'cem-step-body--shadow': step.isRemoved === false }"
              @click="updateVariant(step.rawMaterial)"
            >
              <p
                class="cem-step-body-text"
                :class="{ 'line-through': step.isRemoved === true, 'text-dark': step.isRemoved === false }"
              >
                {{
                  step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0
                    ? getSelectedVariant(step.rawMaterial.variants).name
                    : step.rawMaterial.name
                }}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section v-show="mobileTab === 'ekstra'" class="cem-panel cem-panel--extras" aria-label="Ekstralar">
        <vs-button
          v-if="selectedRecipe.productExtras != null && selectedRecipe.productExtras.length > 0"
          type="gradient"
          color="primary"
          class="cem-open-extras"
          @click="openExtraSelection"
        >
          Ekstra seç
        </vs-button>
        <div v-if="realSelectedExtras && realSelectedExtras.length" class="cem-extra-list">
          <div v-for="extra in realSelectedExtras" :key="extra.id" class="cem-extra-row">
            <span class="cem-extra-name">+ {{ extra.quantity }} {{ extra.name }}</span>
            <span class="cem-extra-price">{{ $toCurrency(extra.quantity * extra.price) }}</span>
          </div>
        </div>
        <p v-else class="cem-muted">Seçili ekstra yok</p>
      </section>

      <section v-show="mobileTab === 'bilgi'" class="cem-panel cem-panel--info" aria-label="Bilgi">
        <p v-if="description" class="cem-desc">{{ description }}</p>
        <p v-else class="cem-muted">Bu ürün için açıklama yok</p>
        <vs-button type="border" color="primary" class="cem-info-btn" @click="openDescription">Detaylı bilgi</vs-button>
      </section>
    </div>

    <vs-row v-if="isExtraSelectionOpen" vs-type="flex" vs-w="12" class="cem-extra-full">
      <extra-selection
        :extras="selectedExtras.length > 0 ? selectedExtras : selectedRecipe.productExtras"
        @saveExtras="saveExtraSelection"
        @cancelExtras="cancelExtraSelection"
      ></extra-selection>
    </vs-row>

    <footer v-if="!isExtraSelectionOpen" class="cem-footer">
      <vs-button class="cem-footer-btn cem-footer-btn--ghost" color="danger" type="border" @click="GoToProductSelectPage" icon-pack="feather" icon="icon-arrow-left">
        Vazgeç
      </vs-button>
      <vs-button
        class="cem-footer-btn cem-footer-btn--primary"
        color="success"
        type="filled"
        :disabled="addToCartInFlight"
        @click.prevent="AddToCart"
        icon-pack="feather"
        icon="icon-arrow-right"
        icon-after
      >
        Onayla
      </vs-button>
    </footer>
  </div>
</template>

<script>
import RecipeReviewer from "@/views/pages/Recipe/RecipeReviewer";
import ExtraSelection from "./ExtrasSelection";
import ProductDescription from "./ProductDescription";
import cartEntryMixin from "./cartEntryMixin";

export default {
  name: "CartEntryMobile",
  components: {
    ExtraSelection,
    RecipeReviewer,
    ProductDescription,
  },
  mixins: [cartEntryMixin],
  data() {
    return {
      mobileTab: "urun",
    };
  },
  computed: {
    displayProductTitle() {
      return (this.productName || []).filter(Boolean).join(" => ");
    },
  },
  methods: {
    onImgError(e) {
      e.target.src = this.productPlaceHolder;
    },
  },
};
</script>

<style scoped lang="scss" src="./CartEntryMobile.scss"></style>
